import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { Grid, Typography } from '@material-ui/core';

import { FooterColorContext } from './FooterColourContext';

const styles = (theme) => ({
    footerRoot: {
        marginTop: 'auto',
        padding: theme.typography.pxToRem(20),
    },
    copyright: {
        fontSize: theme.typography.pxToRem(14),
        color: 'rgba(112, 112, 112, 1)',
    },
    link: {
        fontSize: theme.typography.pxToRem(14),
        color: 'rgba(112, 112, 112, 1)',
        textDecoration: 'none',
        marginLeft: theme.typography.pxToRem(24),
    },
});

const Footer = ({ classes }) => {
    const { footerColor } = useContext(FooterColorContext);

    return (
        <Grid
            className={classes.footerRoot}
            container
            direction="row"
            justify="center"
            alignItems="flex-end"
            style={{ backgroundColor: footerColor }}
        >
            <Grid item>
                <Typography className={classes.copyright}>
                    © Copyright {moment().format('YYYY')} Nexthink
                    <a className={classes.link} href="https://nexthink.com" target="_blank" rel="noreferrer">
                        nexthink.com
                    </a>
                </Typography>
            </Grid>
        </Grid>
    );
};


export default withStyles(styles, { withTheme: true })(Footer);
